import { useLanguage } from "@/context/LanguageContext";
import { buildWaLink } from "@/lib/whatsapp";
import { Lightbulb, Droplets, Check, ArrowUpRight } from "lucide-react";

const Services = () => {
  const { t, lang, isRTL } = useLanguage();

  const cards = [
    {
      key: "electrical",
      icon: Lightbulb,
      accent: "bg-[#FFF3EA] text-[#FF5A00]",
      data: t("services.electrical"),
    },
    {
      key: "plumbing",
      icon: Droplets,
      accent: "bg-[#EEF4FF] text-[#2251B4]",
      data: t("services.plumbing"),
    },
  ];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-28 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF5A00]">
            {t("services.eyebrow")}
          </div>
          <h2
            className="mt-4 text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-[#0B1320] leading-[1.05]"
            style={{
              fontFamily:
                lang === "ar" ? "Tajawal, sans-serif" : "Outfit, sans-serif",
            }}
          >
            {t("services.title")}
          </h2>
          <p className="mt-5 text-lg text-[#475569] max-w-2xl">
            {t("services.subtitle")}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map(({ key, icon: Icon, accent, data }) => (
            <article
              key={key}
              data-testid={`service-card-${key}`}
              className="bg-white border border-[#E2DFD2] rounded-3xl p-8 md:p-10 flex flex-col"
            >
              <div className="flex items-center gap-3">
                <span className={`h-12 w-12 rounded-2xl grid place-items-center ${accent}`}>
                  <Icon size={22} strokeWidth={2} />
                </span>
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#475569]">
                    {data.name}
                  </div>
                  <h3
                    className="text-xl font-black text-[#0B1320] tracking-tight"
                    style={{
                      fontFamily:
                        lang === "ar"
                          ? "Tajawal, sans-serif"
                          : "Outfit, sans-serif",
                    }}
                  >
                    {data.tagline}
                  </h3>
                </div>
              </div>

              <ul className="mt-6 space-y-3">
                {(data.items || []).map((it, i) => (
                  <li key={i} className="flex items-start gap-3 text-[#475569]">
                    <span className="mt-1 h-5 w-5 rounded-full bg-[#FF5A00]/10 grid place-items-center shrink-0">
                      <Check size={12} className="text-[#FF5A00]" strokeWidth={3} />
                    </span>
                    <span className="text-base">{it}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 pt-6 border-t border-[#E2DFD2]">
                <a
                  data-testid={`service-book-${key}`}
                  href={buildWaLink(
                    `${t("whatsapp.msg_default")}(${data.name})`
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#0B1320] hover:text-[#FF5A00] transition-colors"
                >
                  {t("nav.book")}
                  <ArrowUpRight
                    size={16}
                    className={isRTL ? "scale-x-[-1]" : ""}
                  />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
